export default {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    width: '100%',
    flex: 1,
  },

  contractWrapper: {
    paddingBottom: '12px',
  },
  title: {
    fontSize: '1.05rem',
    fontWeight: 600,
    color: (theme) => theme.palette.grays.gray700,
  },
  contractRow: {
    width: '100%',
    display: 'flex',
    gap: '12px',
    flexDirection: 'column',

    a: {
      textDecoration: 'none',
      fontWeight: 500,
      color: (theme) => theme.palette.blues.primaryBlue500,
    },
  },
  contractLabel: {
    fontWeight: 500,
    fontSize: '0.875rem',
    color: (theme) => theme.palette.grays.gray500,
  },

  createButton: {
    width: 'auto',
    alignSelf: 'flex-start',
  },
};
